import ClipBoard from 'clipboard';
import React, { useEffect, useRef } from 'react';
import { Clipboard } from 'lucide-react';

export function ClipboardText({ value }) {
  const buttonRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const clipboard = new ClipBoard(buttonRef.current, {
      target: () => inputRef.current,
    });
    return () => clipboard.destroy();
  }, []);

  return (
    <p className="flex items-center gap-2">
      <span ref={inputRef}>{value}</span>
      <button
        ref={buttonRef}
        type="button"
        className="inline-flex items-center justify-center p-1.5 rounded-lg border border-gray-300 text-gray-500 hover:text-primary-900 hover:border-primary-900 transition-colors"
      >
        <Clipboard className="w-3.5 h-3.5" />
      </button>
    </p>
  );
}
